import { useContext } from "react";
import Page from "./Page";
import jobContext from "src/context/jobContext";

export default function SessionIntro({ sessionNumber, pageNumber, sessionDesc = "", sessionTitle = "" }) {
    const { job } = useContext(jobContext)
    const translate = {
        1: "فصل اول",
        2: "فصل دوم",
        3: "فصل سوم",
        4: "فصل چهارم",
        5: "فصل پنجم",
        6: "فصل ششم",
        7: "فصل هفتم",
        8: "فصل هشتم",
        9: "فصل نهم",
        10: "فصل دهم",
    }

    let baseInfo
    let jobTitle = job.title;
    if (localStorage.baseInfo) {
        baseInfo = JSON.parse(localStorage.baseInfo)
        jobTitle = baseInfo.jobTitle ?? job.title;
    }
    return (
        <Page pageNumber={pageNumber} className="h-2/3 !p-16">
            <div className="flex flex-col justify-center items-center w-full h-full mt-[400px]">
                <div className="flex w-full">
                    <div className="relative flex flex-col gap-6 text-gray-700 border-[60px] border-solid border-[#5b5cff] rounded-3xl w-full h-[360px] items-center justify-center text-7xl">
                        <span className="text-shadow font-extrabold absolute top-10 text-[100px]">{sessionNumber}</span>
                    
                        <span className="text-xl absolute bottom-11 text-gray-600 font-bold">{sessionTitle}</span>
                        <span className="text-2xl text-shadow absolute -bottom-11 text-white">{translate[sessionNumber]}</span>
                        <img className="w-[160px] absolute -top-[230px]" src={job.organization ? process.env.REACT_APP_API_URL + "/img/" + job.organization.logo : `assets/img/logo.jpg`} />
                        {/* <div className="absolute -bottom-[100px] font-medium flex gap-2 text-lg text-gray-800">
                            <span>شبکه جامع مشاغل</span>
                            <span> - www.jobonet.ir</span>
                        </div> */}
                    </div>
                    <div className="relative w-full flex flex-col ">
                        <div className="absolute top-16 text-justify p-6 h-[165px] text-sm">{sessionDesc}</div>
                        {/* <div className="w-full h-[100px] bg-[#5b5cff] text-white flex justify-center items-center text-2xl rounded-l-3xl">{sessionTitle}</div> */}
                        <div className="absolute bottom-20 w-[320px] flex justify-center items-center text-sm h-[60px] left-4 bg-gray-100 p-2 rounded-xl border-solid">{jobTitle}</div>
                    </div>
                </div>
            </div>
        </Page>
    )
}